import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setCategories, setLoading, setSingleCategory } from "../../repository/slice";

function* getSingleCategoryWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/category/get/" + payload.id);
        if (isError) {

        } else {
            yield put(setSingleCategory(data));
        }
    } catch (error) {
        console.error("getSingleCategoryWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSingleCategoryWatcher() {
    yield takeLatest("@saga/GET_SINGLE_CATEGORY", getSingleCategoryWorker);
};
